import { forwardRef, InputHTMLAttributes } from 'react';
import { cn } from './cn';
import { Label } from './label';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, className, id, ...props }, ref) => {
    const input = (
      <input
        ref={ref}
        id={id}
        className={cn(
          'flex h-8 w-full rounded-lg border border-nova-input bg-transparent px-2.5 text-sm text-nova-foreground',
          'placeholder:text-nova-muted-foreground',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-nova-ring/30',
          'disabled:cursor-not-allowed disabled:opacity-50',
          error && 'border-red-500 focus-visible:ring-red-500/30',
          className
        )}
        {...props}
      />
    );

    if (!label && !error) return input;

    return (
      <div className="w-full">
        {label ? (
          <Label htmlFor={id} className="mb-1.5 block">
            {label}
          </Label>
        ) : null}
        {input}
        {error ? <p className="mt-1 text-xs text-red-600">{error}</p> : null}
      </div>
    );
  }
);

Input.displayName = 'Input';
